<template>
    <div>
        <div class="progress"
            v-bind:style="{ height: height}"
        >
            <div class="progress-bar progress-bar-striped"
                role="progressbar"
                :aria-valuenow="value"
                :aria-valuemin="min"
                :aria-valuemax="max"
                v-bind:style="{ width: progressWidth}"
            />
            {{ text }}
        </div>
        <h6 class="text-center">{{ description }}</h6>
    </div>
</template>

<script>
export default {
    name: 'ProgressBarComponent',
    props: {
        value: {
            type: Number,
            default() {
                return 0;
            }
        },
        min: {
            type: [Number, String],
            default() {
                return 0;
            }
        },
        max: {
            type: [Number, String],
            default() {
                return 100;
            }
        },
        show: {
            type: Boolean,
            default() {
                return false;
            }
        },
        height: {
            type: String,
            default() {
                return '20px'
            }
        },
        text: {
            type: String,
            default() {
                return ''
            }
        },
        description: {
            type: String,
            default() {
                return ''
            }
        }
    },
    computed: {
        progressWidth() {
            const max = typeof this.max === 'number' ? this.max : Number(this.max);

            if (!this.value || !max) return '';

            const width = ((this.value / max) * 100).toFixed(0);
            return `${width}%`;
        }
    }
}
</script>
